module.exports = "<div id=\"main\" class=\"pure-u-1\" v-show=\"topic.id\">\n    <div class=\"content\" v-html=\"topic.content\"></div>\n  </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/article.vue
 ** module id = 19
 ** module chunks = 0
 **/